'use client'
import DashboardMenu from 'app/dashboard/shared/DashboardMenu'
import { MenuIcon, XMarkIcon } from '@styleguide/components/ui/icons'
import { useEffect } from 'react'
import { noop } from '@shared/utils/noop'

const disableScroll = () => {
  window.scrollTo(0, 0)
  window.onscroll = () => {
    window.scrollTo(0, 0)
  }
}

const enableScroll = () => {
  window.onscroll = noop
}

interface TopDashboardMenuProps {
  open: boolean
  toggleCallback: () => void
  pathname: string
}

const TopDashboardMenu = ({
  open,
  toggleCallback,
  pathname,
}: TopDashboardMenuProps): React.JSX.Element => {
  useEffect(() => {
    if (open) {
      disableScroll()
    } else {
      enableScroll()
    }
  }, [open])

  return (
    <div className="lg:hidden">
      <button
        type="button"
        onClick={toggleCallback}
        aria-label={open ? 'Close menu' : 'Open menu'}
        aria-expanded={open}
        className="flex h-12 w-12 items-center justify-center"
      >
        {open ? <XMarkIcon size={24} /> : <MenuIcon size={24} />}
      </button>
      {open && (
        <div className="fixed top-14 left-0 w-screen h-[calc(100vh-56px)] bg-indigo-50 p-2 overflow-x-hidden overflow-y-auto">
          <DashboardMenu pathname={pathname} />
        </div>
      )}
    </div>
  )
}

export default TopDashboardMenu
